import { createRouter, createWebHistory } from 'vue-router'
import type { App } from 'vue'
import { routes } from './routes'
import { registerGuards } from './guards'

const router = createRouter({
	history: createWebHistory(),
	routes
})

registerGuards(router)

export { router as Router }

export default (app: App) => {
	app.router = router
	app.use(router)
}
